/**
 * @file PeriodicityAttentionListView.jsx
 * @author Fernando Ruano
 * @description Periodicity Attention List View Page
 */

// Dependencies
import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import moment from 'moment';

// Helpers
import { sortString } from 'commons/helpers/utils';
import {
  getDefaultColumns,
  PAGE_LIMIT,
  setBadgeVariation
} from '../helper/utils';
import DashboardDetailList from '../dashboardDetailList';

function PeriodicityAttentionListView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const [rowData, setRowData] = React.useState([]);
  const { classification, totalItems, frequency } = useParams();

  const { getPeriodicityAttentionList } = dashboardStaffActions;

  const columns = [...getDefaultColumns(translate)];

  const additionalColumns = [
    {
      title: translate('Fecha última revisión trabajo social'),
      dataIndex: 'fecha_tipo_ultima_revision_ts',
      sorter: sortString('fecha_tipo_ultima_revision_ts'),
      ellipsis: true
    },
    {
      title: translate('Tipo última revisión trabajo social'),
      dataIndex: 'tipo_ultima_revision_ts',
      sorter: sortString('tipo_ultima_revision_ts'),
      ellipsis: true
    }
  ];

  const getetData = (offset, pageLimit) => {
    const pageSize = pageLimit || PAGE_LIMIT;
    const data = {
      classification,
      frequency,
      clinicId,
      limit: pageSize,
      offset
    };
    getPeriodicityAttentionList(data, (_, resp) => {
      if (resp?.data) {
        const adapter = resp.data.map((item) => {
          return {
            ...item,
            fecha_tipo_ultima_revision_ts: item?.fecha_tipo_ultima_revision_ts
              ? moment
                  .utc(item.fecha_tipo_ultima_revision_ts)
                  .format('DD-MM-YYYY')
              : ''
          };
        });
        setRowData(setBadgeVariation(adapter));
      }
    });
  };

  React.useEffect(() => {
    if (clinicId !== null) getetData(1);
  }, [clinicId]);

  return (
    <DashboardDetailList
      columns={columns}
      rowData={rowData}
      totalItems={totalItems}
      additionalColumns={additionalColumns}
      onPaginationChange={getetData}
    />
  );
}

/**
 * Component definition of proptypes.
 */
PeriodicityAttentionListView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getPeriodicityAttentionList: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default PeriodicityAttentionListView;
